export const adminTypes = [
  "Admin",
  "Leidinggevende",
  "Mail / rooster",
  "Admin lonen",
];

export const userTypes = {
  ADMIN: "admin",
  STAFF: "staff",
};

export const weekDays = {
  A: {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  },
  B: {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  },
};

export const personnelStatus = {
  PLANNED: "successBadge",
  AVAILABLE: "warningBadge",
  UNAVAILABLE: "defaultBadge",
};

export const jobFilterTypes = {
  KITCHEN: 1,
  NON_KITCHEN: 2,
  DISHES: 3,
};

export const callListJobGroup = {
  Kitchen: 1,
  "Non Kitchen": 2,
  Dishes: 3,
};

// Job-filter-specific Newbee/Rookie tag ids that replace the global tags
// (14 = Newbee, 15 = Rookie) on the /main and /new-rooster screens, depending
// on which job filter view is currently active.
//
// NOTE: keyed by job filter `type_id` (see jobFilterTypes above /
// App\Models\JobFilterType on the API side), NOT by job filter `name`.
// The `name` of a job filter is location-specific free text (admins can
// rename it), so it is not a reliable cross-location key. `type_id` is the
// value that's consistent across locations.
export const newbeeRookieTagIdsByJobFilterType = {
  [jobFilterTypes.KITCHEN]: { newbee: 21, rookie: 24 },
  [jobFilterTypes.NON_KITCHEN]: { newbee: 20, rookie: 23 },
  [jobFilterTypes.DISHES]: { newbee: 19, rookie: 22 },
};

// Horeca locations excluded from the job-filter-specific Newbee/Rookie tag
// behavior above; these keep showing the legacy global tags 14/15 as-is.
export const NEWBEE_ROOKIE_EXCLUDED_LOCATION_IDS = [6];
